// @tenorlab/nuxt-dashboard-pro
// file: app/dashboard-defaults.ts
import type {
  TDashboardWidgetKey,
  IChildWidgetConfigEntry,
  IDashboardConfig,
  TDashboardWidgetCatalog,
} from '@tenorlab/vue-dashboard'
import { blankDashboardConfig, cssSettingsCatalog } from '@tenorlab/vue-dashboard/core'
import { getWidgetCatalog } from './widgets-catalog'

export const filterDefaultWidgets = (
  keys: string[],
  availableWidgetKeys: TDashboardWidgetKey[],
): TDashboardWidgetKey[] => {
  return keys.filter(
    (x) => x.includes('WidgetContainer') || availableWidgetKeys.indexOf(x as any) > -1,
  ) as TDashboardWidgetKey[]
}

export const filterDefaultChildWidgets = (
  entries: IChildWidgetConfigEntry[],
  availableWidgetKeys: TDashboardWidgetKey[],
): IChildWidgetConfigEntry[] => {
  return entries.filter(
    (x) => x.widgetKey.includes('WidgetContainer') || availableWidgetKeys.indexOf(x.widgetKey as any) > -1,
  )
}

// reserved identifier to be used only for the default dashboard
export const DEFAULT_DASHBOARD_ID = 'default' as const
export const DEFAULT_DASHBOARD_NAME = 'Default' as const

// default dashboard config for Regular user type
const getDefaultDashboardForRegularUser = (
  user: any,
  clientAppKey: string,
  availableWidgetKeys: TDashboardWidgetKey[],
): IDashboardConfig => {
  // Define default layout and widgets here if needed
  // filter by availableWidgetKeys from catalog
  const defaultWidgets = filterDefaultWidgets(
    [
      'WidgetContainerRow_container1',
      'WidgetContainer_container2',
      'WidgetBarGradients',
      'WidgetContainerLarge_container3',
      'WidgetRevenueTrendsAsync',
      'WidgetRecentProjects',
    ],
    availableWidgetKeys,
  )

  const defaultChildWidgetsConfig: IChildWidgetConfigEntry[] = filterDefaultChildWidgets(
    [
      {
        parentWidgetKey: 'WidgetContainerRow_container1',
        widgetKey: 'WidgetSmallCardTransparentSample1',
      },
      {
        parentWidgetKey: 'WidgetContainerRow_container1',
        widgetKey: 'WidgetSmallCardTransparentSample2',
      },
      {
        parentWidgetKey: 'WidgetContainerRow_container1',
        widgetKey: 'WidgetSmallCardTransparentSample3',
      },
      {
        parentWidgetKey: 'WidgetContainerRow_container1',
        widgetKey: 'WidgetSmallCardTransparentSample4',
      },
      {
        parentWidgetKey: 'WidgetContainer_container2',
        widgetKey: 'WidgetTotalOrders',
      },
      {
        parentWidgetKey: 'WidgetContainer_container2',
        widgetKey: 'WidgetRecentOrders',
      },
      {
        parentWidgetKey: 'WidgetContainerLarge_container3',
        widgetKey: 'WidgetRecentPayments',
      },
      {
        parentWidgetKey: 'WidgetContainerLarge_container3',
        widgetKey: 'WidgetCreditOverview',
      },
      {
        parentWidgetKey: 'WidgetContainerLarge_container3',
        widgetKey: 'WidgetOutstandingBalance',
      },
      {
        parentWidgetKey: 'WidgetContainerLarge_container3',
        widgetKey: 'WidgetCommodityPrices',
      },
    ],
    availableWidgetKeys,
  )

  const userID = user.userID || 0
  return {
    userID,
    clientAppKey,
    dashboardId: DEFAULT_DASHBOARD_ID,
    dashboardName: DEFAULT_DASHBOARD_NAME,
    zoomScale: 1,
    responsiveGrid: true,
    widgets: defaultWidgets,
    childWidgetsConfig: defaultChildWidgetsConfig,
    cssSettings: [...cssSettingsCatalog],
  }
}

// // default dashboard config for Admin user type
// const getDefaultDashboardForAdminUser = (
//   user: any,
//   clientAppKey: string,
//   availableWidgetKeys: TDashboardWidgetKey[],
// ): IDashboardConfig => {
//   // Define default layout and widgets here if needed
//   // filter by availableWidgetKeys from catalog
//   const defaultWidgets = filterDefaultWidgets(
//     [
//       'WidgetContainer_container1',
//       'WidgetContainer_container2',
//       'WidgetOrderStatus',
//     ],
//     availableWidgetKeys,
//   )

//   const defaultChildWidgetsConfig: IChildWidgetConfigEntry[] = filterDefaultChildWidgets(
//     [
//       {
//         parentWidgetKey: 'WidgetContainer_container1',
//         widgetKey: 'WidgetTotalOrders',
//       },
//       {
//         parentWidgetKey: 'WidgetContainer_container1',
//         widgetKey: 'WidgetTopProducts',
//       },
//     ],
//     availableWidgetKeys,
//   )

//   const userID = user.userID || 0
//   return {
//     userID,
//     clientAppKey,
//     dashboardId: DEFAULT_DASHBOARD_ID,
//     dashboardName: DEFAULT_DASHBOARD_NAME,
//     zoomScale: 1,
//     widgets: defaultWidgets,
//     childWidgetsConfig: defaultChildWidgetsConfig,
//   }
// }

export const getDashboardDefaults = async (
  user: any | null,
  clientAppKey: string,
): Promise<{
  dashboardConfig: IDashboardConfig
  widgetsCatalog: TDashboardWidgetCatalog
}> => {
  const widgetsCatalog = await getWidgetCatalog(user)

  if (!user) {
    return {
      dashboardConfig: blankDashboardConfig,
      widgetsCatalog,
    }
  }

  //if (hasPermission(user, 'regular')) {
  return {
    // Optional, you could use different routines depending on user role:
    dashboardConfig: getDefaultDashboardForRegularUser(user, clientAppKey, [...widgetsCatalog.keys()]),
    widgetsCatalog,
  }
  // } else () {
  //   return {
  //     dashboardConfig: getDefaultDashboardForAdminUser(
  //       user,
  //       clientAppKey,
  //       [...widgetsCatalog.keys()]
  //     ),
  //     widgetsCatalog,
  //   };
  // }

  // return {
  //   dashboardConfig: blankDashboardConfig,
  //   widgetsCatalog,
  // }
}
